import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';
import {
  ComptesPaieInvalideError,
  COMPTES_PAIE_PAR_DEFAUT,
  ROLES_COMPTE_PAIE,
  resoudreComptesPaie,
  type SurchargesComptesPaie,
  type TableComptesPaie,
} from '@domain/comptabilite/ComptesPaie';
import { logger } from '@infra/telemetry/Logger';

const KEY = 'compta.comptes_paie';

/** Ne garde que les surcharges différentes des valeurs par défaut (stockage minimal et lisible). */
function surchargesDepuisTable(table: TableComptesPaie): SurchargesComptesPaie {
  const out: SurchargesComptesPaie = {};
  for (const role of ROLES_COMPTE_PAIE) {
    if (table[role] !== COMPTES_PAIE_PAR_DEFAUT[role]) out[role] = table[role];
  }
  return out;
}

/** Table de correspondance de l'entreprise ; une valeur stockée invalide retombe sur les défauts (journalisé). */
export async function loadComptesPaie(tenantId: string): Promise<TableComptesPaie> {
  const raw = await SecureTenantStore.getJson<unknown>(tenantId, KEY, {});
  if (raw === null || typeof raw !== 'object' || Array.isArray(raw)) return COMPTES_PAIE_PAR_DEFAUT;
  try {
    return resoudreComptesPaie(raw as SurchargesComptesPaie);
  } catch (err) {
    if (!(err instanceof ComptesPaieInvalideError)) throw err;
    logger.warn({ event: 'comptes_paie_invalides', message: err.message });
    return COMPTES_PAIE_PAR_DEFAUT;
  }
}

/** Enregistre la table (validée) ; lève `ComptesPaieInvalideError` si elle est incohérente. */
export async function saveComptesPaie(
  tenantId: string,
  surcharges: SurchargesComptesPaie,
): Promise<TableComptesPaie> {
  const table = resoudreComptesPaie(surcharges);
  await SecureTenantStore.setJson(tenantId, KEY, surchargesDepuisTable(table));
  return table;
}
